import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Title, Logo, SocialAuth } from '../components'
import { SignUpForm } from '../forms'
import { facebookAuth, googleAuth } from '../../common/auth/actions'
import { signUp } from '../../common/users/actions'
import { roles, roleTypes } from '../../common/config'

class SignUpPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showForm: false,
    }
  }

  render() {
    const { location, currentTest, viewer, signUp, registeringUser, redirectAfterAuth, intl } = this.props
    const { showForm } = this.state
    const redirectUrl = redirectAfterAuth

    if (!viewer && !registeringUser) {
      return <Redirect to="/sign-up" />
    }

    let redirectComponent = <Redirect to={redirectUrl || '/student-landing'} />

    if (viewer && viewer.role === roles.TEACHER) {
      redirectComponent = <Redirect to="/app/tests" />
    }
    
    return (
      viewer
      ?
        redirectComponent
      :
        <div className="overlay-container">
          <div className="user-form-wrapper sign-up-form">
            <div className="user-form">
              <Title message="Sign up" />
              <Logo size="medium" />
              <h1>{intl.formatMessage(messages.signUp)}</h1>
              {/*
              <SocialAuth
                facebookLabel={intl.formatMessage(messages.facebookLabel)}
                googleLabel={intl.formatMessage(messages.googleLabel)}
              />
              <p className="form-divider">
                {intl.formatMessage(messages.or)}
              </p>
              */}
              <SignUpForm signUp={signUp} />
              {/*
                showForm ?
                  <SignUpForm signUp={signUp} />
                :
                  <Button
                    positive
                    className="user-form-button"
                    icon="envelope"
                    onClick={() => this.setState({ showForm: true })}
                  >
                    {intl.formatMessage(messages.emailSignUp)}
                  </Button>
              */}
              <p>
                {intl.formatMessage(messages.alreadyRegistered)}<br />
                <Link to="/sign-in"><b>{intl.formatMessage(messages.signIn)}</b></Link>
              </p>
            </div>
          </div>
          {
            registeringUser.role === roles.TEACHER &&
            <div className="app-benefits">
              <div className="app-benefits-text">
                {
                  currentTest ?
                    <React.Fragment>
                      <h3>
                        {intl.formatMessage(messages.testIsReady,
                          { name: currentTest.name, address: currentTest.testId })}
                      </h3>
                      <img
                        style={{ width: '50rem' }}
                        src="/assets/images/computer-room.png"
                        alt="Computer room"
                      />
                      <p>
                        {intl.formatMessage(messages.teacherAfterSignUp)}
                      </p>
                      <ul>
                        <li>{intl.formatMessage(messages.teacherBenefit4)}</li>
                        <li>{intl.formatMessage(messages.teacherBenefit5)}</li>
                        <li>{intl.formatMessage(messages.teacherBenefit6)}</li>
                      </ul>
                    </React.Fragment>
                  :
                    <React.Fragment>
                      <h3>{intl.formatMessage(messages.afterSignUp)}</h3>
                      <ul>
                        <li>{intl.formatMessage(messages.teacherBenefit1)}</li>
                        <li>{intl.formatMessage(messages.teacherBenefit2)}</li>
                        <li>{intl.formatMessage(messages.teacherBenefit3)}</li>
                      </ul>
                    </React.Fragment>
                }              
              </div>
            </div>
          }
          {
            registeringUser.role === roles.USER &&
            <div className="app-benefits">
              <div className="app-benefits-text">
                <h3>{intl.formatMessage(messages.afterSignUp)}</h3>
                <ul>
                  <li>{intl.formatMessage(messages.studentBenefit1)}</li>
                  <li>{intl.formatMessage(messages.studentBenefit2)}</li>
                </ul>
              </div>
            </div>
          }
        </div>
    )
  }
}

SignUpPage.defaultProps = {
  viewer: null,
  registeringUser: null,
  currentTest: null,
  redirectAfterAuth: '',
}

SignUpPage.propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  currentTest: PropTypes.object,
  registeringUser: PropTypes.object,
  signUp: PropTypes.func.isRequired,
  redirectAfterAuth: PropTypes.string,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    registeringUser: state.users.registeringUser,
    currentTest: state.tests.currentTest,
    redirectAfterAuth: state.app.redirectAfterAuth,
  }), { signUp, facebookAuth, googleAuth }),
  injectIntl,
)

export default enhance(SignUpPage)

const messages = defineMessages({
  signUp: {
    id: 'signup.page.title',
    defaultMessage: 'Registrovať sa',
  },
  or: {
    id: 'general.or',
    defaultMessage: 'alebo',
  },
  emailSignUp: {
    id: 'signup.page.emailSignUp',
    defaultMessage: 'Registrovať sa cez email',
  },
  facebookLabel: {
    id: 'socialAuth.facebookLabel',
    defaultMessage: 'Pokračovať cez Facebook',
  },
  googleLabel: {
    id: 'socialAuth.googleLabel',
    defaultMessage: 'Pokračovať cez Google',
  },
  alreadyRegistered: {
    id: 'signup.page.alreadyRegistered',
    defaultMessage: 'Máte už vytvorený učet?',
  },
  signIn: {
    id: 'signup.page.signIn',
    defaultMessage: 'Prihlásiť sa',
  },
  testIsReady: {
    id: 'signup.page.testIsReady',
    defaultMessage: 'Test {name} je pripravený pre žiakov na adrese: vobo.io/test/{address}',
  },
  teacherAfterSignUp: {
    id: 'signup.page.teacherAfterSignUp',
    defaultMessage: 'Test dostal pridelenú adresu, na ktorej je prístupný pre žiakov. Dokončite registráciu aby ste mohli:',
  },
  afterSignUp: {
    id: 'signup.page.afterSignUp',
    defaultMessage: 'Po registrácii môžete',
  },
  teacherBenefit1: {
    id: 'signup.page.teacherBenefit1',
    defaultMessage: 'vytvárať vlastné cvičenia a testy',
  },
  teacherBenefit2: {
    id: 'signup.page.teacherBenefit2',
    defaultMessage: 'nechať testy opraviť aplikáciu za Vás',
  },
  teacherBenefit3: {
    id: 'signup.page.teacherBenefit3',
    defaultMessage: 'spojiť sa s ostatnými učiteľmi a zdielať medzi sebou cvičenia',
  },
  teacherBenefit4: {
    id: 'signup.page.teacherBenefit4',
    defaultMessage: 'zobraziť adresu testu',
  },
  teacherBenefit5: {
    id: 'signup.page.teacherBenefit5',
    defaultMessage: 'prezerať výsledky po vyplnení testu',
  },
  teacherBenefit6: {
    id: 'signup.page.teacherBenefit6',
    defaultMessage: 'vytvárať ďalšie testy',
  },
  studentBenefit1: {
    id: 'signup.page.studentBenefit1',
    defaultMessage: 'vytvárať si vlastné zoznamy slovíčok',
  },
  studentBenefit2: {
    id: 'signup.page.studentBenefit2',
    defaultMessage: 'študovať zoznamy iných uživateľov',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/SignUpPage.js